<template>
	<div
		:class="[
			'c-block-list-quote-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<div v-if="quote" class="flex flex-col >=768:flex-row items-start">
			<div class="w-1col >=768:mr-layout-gutter flex-shrink-0">
				<SvgQuote class="w-full h-full" />
			</div>
			<div class="flex flex-col align-start">
				<blockquote
					class="text-h3 text-text font-bold italic pt-sm >=768:pt-0"
				>
					{{ quote }}
				</blockquote>
				<cite class="pt-xs">{{ origin }}</cite>
			</div>
		</div>
	</div>
</template>

<script>
import SvgQuote from '~/assets/svgs/quote-icon.svg?inline';
export default {
	name: 'BlockListQuoteCustom',
	components: { SvgQuote },
	inheritAttrs: false,

	props: {
		origin: String,
		quote: String,
	},
};
</script>
